import * as React from 'react';

import { MultiraceProgram } from '@/lib/apollo/types/gen/graphql';
import { multiraceProgramSelector } from '@/selectors/multiraceProgram';

import { BetLink, Cancel, NotReleaseText, ResultLink } from './style';

interface RaceLinkProps {
  isSale: boolean;
  isReleased: boolean;
  multiraceProgram: MultiraceProgram;
  velodromeName: string;
}

const RaceLink: React.FC<RaceLinkProps> = ({
  isSale,
  isReleased,
  multiraceProgram,
  velodromeName,
}) => {
  if (multiraceProgramSelector(multiraceProgram).isCanceled) {
    return <Cancel>中止</Cancel>;
  }

  if (isSale) {
    if (!isReleased) {
      return <NotReleaseText>発売前</NotReleaseText>;
    }
    return (
      <BetLink
        to={`/${velodromeName}/lottery/${multiraceProgram.heldDate.format(
          'YYYY-MM-DD',
        )}/${multiraceProgram.multiraceType}`}
      >
        投票
      </BetLink>
    );
  }

  return (
    <ResultLink
      to={`/${velodromeName}/lottery/${multiraceProgram.heldDate.format(
        'YYYY-MM-DD',
      )}/result`}
    >
      結果
    </ResultLink>
  );
};

export default RaceLink;
